var render = function render(){var _vm=this,_c=_vm._self._c;return _c('modal-card',{attrs:{"title":"Token call logs","cancel-text":"Close"}},[_c('call-logs-table',{attrs:{"token-ref":_vm.tokenRef}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }